import React, { useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip } from "reactstrap";
import isOverflowing from "shared/utils/isOverflowing";

const TruncateTextWithTooltip = ({ className, minWidth, component: Component, placement, ...props }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const ref = useRef();

  const toggle = useCallback(
    () => setTooltipOpen(currentState => isOverflowing(ref.current) && !currentState),
    []
  );

  return (
    <div className="flex-grow-1 align-self-center" style={{ minWidth }} data-selector="container">
      <Component
        ref={ref}
        className={classNames("text-truncate", className)}
        {...props}
        data-selector="content"
      />
      <Tooltip placement={placement} isOpen={tooltipOpen} target={ref} toggle={toggle}>
        {props.children}
      </Tooltip>
    </div>
  );
};

TruncateTextWithTooltip.propTypes = {
  /** className to apply to the content div */
  className: PropTypes.string,
  /** minWidth to apply to the container div as a style */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** the component to be used for text content */
  component: PropTypes.elementType,
  /** tooltip placement */
  placement: PropTypes.string
};

TruncateTextWithTooltip.defaultProps = {
  className: "",
  minWidth: 0,
  component: "div",
  placement: "top"
};

export default TruncateTextWithTooltip;
